import { useCallback } from 'react';

import { ContentType } from 'services/data-manager/types';

import {
    metadataTypeToRibbonType,
    stripeDimensions,
    stripeMargins,
} from 'components/CustomButtons/RibbonTouchable/styles';

const useGetItemLayout = (metadataType: ContentType) => {
    return useCallback(
        (data, index) => {
            const ribbonType = metadataTypeToRibbonType[metadataType];

            if (
                ribbonType &&
                stripeDimensions[ribbonType] &&
                stripeMargins[metadataType]
            ) {
                const width =
                    stripeDimensions[ribbonType].width +
                    stripeMargins[metadataType]!.marginRight;
                const offset = width * index;

                return {
                    length: width,
                    offset,
                    index,
                };
            }

            // Return a default layout when the condition is not met
            return {
                length: 0, // Set the appropriate length based on your requirements
                offset: 0,
                index,
            };
        },
        [metadataType],
    );
};

export default useGetItemLayout;
